import * as H from 'history';
import { match } from 'react-router';
import {
    User,
    Users,
    Search,
    Autocomplete,
    StockDetails,
    Cart,
    Orders,
    Checkout,
    Fitments,
    CategoriesAndCertification,
    Picture,
    Warehouse,
    Insurance,
    AdminNavigation,
    ChangePassword,
    Internal,
    Admin,
    Configuration,
    ShippingListUpload
} from '.';

// Store interface
export interface IAppStore {
    user: User;
    users: Users;
    search: Search;
    autocomplete: Autocomplete;
    stock: StockDetails;
    cart: Cart;
    orders: Orders;
    checkout: Checkout;
    fitments: Fitments;
    categories: CategoriesAndCertification;
    gallery: Picture;
    warehouse: Warehouse;
    insurance: Insurance;
    adminNavigation: AdminNavigation;
    changePassword: ChangePassword;
    internal: Internal;
    admin: Admin;
    configuration: Configuration;
    shippingListUpload: ShippingListUpload;
}

// Construct stores
export const user = new User();
export const users = new Users();
export const search = new Search();
export const autocomplete = new Autocomplete();
export const stock = new StockDetails();
export const fitments = new Fitments();
export const cart = new Cart();
export const orders = new Orders();
export const checkout = new Checkout();
export const categories = new CategoriesAndCertification();
export const gallery = new Picture();
export const warehouse = new Warehouse();
export const insurance = new Insurance();
export const adminNavigation = new AdminNavigation();
export const changePassword = new ChangePassword();
export const internal = new Internal();
export const admin = new Admin();
export const configuration = new Configuration();
export const shippingListUpload = new ShippingListUpload();

// Initialize main store
const store: IAppStore = {
    user,
    users,
    search,
    autocomplete,
    stock,
    cart,
    orders,
    checkout,
    fitments,
    categories,
    gallery,
    warehouse,
    insurance,
    adminNavigation,
    changePassword,
    internal,
    admin,
    configuration,
    shippingListUpload
};

// App interface
export interface IApp {
    store?: IAppStore;
    readonly history?: H.History;
    readonly location?: H.Location;
    readonly match?: match<any>;
    readonly params?: { [param: string]: string };
}

export interface IAppOnlyStore {
    store?: IAppStore;
}

export default store;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/AllStores.ts